import { buildAnalytics } from '~/analytics'

export default defineNuxtPlugin(({ $gaApp, $gtm }) => {
  const libs = {
    gtm: $gtm,
  }

  return {
    provide: {
      analytics: buildAnalytics($gaApp, libs),
    },
  }
})
